import React from "react";
import {Link} from "react-router-dom";
import {AiSettingsAutorunSystemExtractor} from "../../domain/AiSettings";
import * as styles from "./AiSettingsPage.module.css";

export const ORGANIZATION_SOURCE_AUTORUN_HELP =
    "Runs autorun-enabled system extractors on items from organization sources. This adds included system AI attributes (like AI summary) to items from organization's sources. Consumes additional AI credits. Manual extractor <-> source assignments still work and are added to this.";

interface Props {
    extractors?: AiSettingsAutorunSystemExtractor[];
}

function AutorunSystemExtractorsInfo({extractors}: Props) {
    const items = extractors ?? [];

    return (
        <div className={styles["autorun-extractors"]}>
            <div className={styles["autorun-extractors-description"]}>
                System extractors with autorun enabled:
            </div>

            {items.length === 0
                ? <i>No system extractors are enabled for organization source autorun.</i>
                : (
                    <ul>
                        {items.map(extractor => (
                            <li key={extractor.id}>
                                <Link to={`/definitions/ai-extractors/${extractor.id}`}>{extractor.name || extractor.id}</Link>
                                {renderAiAttributes(extractor)}
                            </li>
                        ))}
                    </ul>
                )
            }
        </div>
    );

    function renderAiAttributes(extractor: AiSettingsAutorunSystemExtractor) {
        if (!extractor.aiAttributes?.length) {
            return null;
        }

        return (
            <span>
                {" - "}
                {extractor.aiAttributes.map((aiAttribute, index) => (
                    <React.Fragment key={aiAttribute.id}>
                        {index > 0 && ", "}
                        <Link to={`/definitions/ai-attributes/${aiAttribute.id}`}>{aiAttribute.name || aiAttribute.id}</Link>
                    </React.Fragment>
                ))}
            </span>
        );
    }
}

export default AutorunSystemExtractorsInfo;
